// extracted by mini-css-extract-plugin
export default {"footer":"j8L78Rk3n6Z1hBXjSzZQ","title":"IbTWpe5JlBhKzYc2uQaS","link":"guRX88UBgkS72ru2WY6z","badge":"X1s_CTNtGakkgRVwI2m_","language":"WpZUQgZ9F8mMkGtx4WrC"};